import React, { Fragment, isValidElement, cloneElement } from 'react';

const defaultLinkComponent = (url, text, key, className) => React.createElement("a", {
  className: className,
  key: `${url}-${key}`,
  href: url,
  target: "_blank",
  rel: "noreferrer"
}, text);

const defaultLinksRegex = /(https?:\/\/|www\.)([-\w.]+\/[\p{L}\p{Emoji}\p{Emoji_Component}!#$%&'"()*+,./\\:;=_?@[\]~-]*[^\s'",.;:\b)\]\}?]|(([\w-]+\.)+[\w-]+[\w\/-]))/u;
const ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
/**
 * Make urls clickable.
 * @param text Text to parse
 * @param options {@link Options}
 */

function addLinks(text, options) {
  var _options$regex, _options$component;

  const linksRegex = (_options$regex = options === null || options === void 0 ? void 0 : options.regex) !== null && _options$regex !== void 0 ? _options$regex : defaultLinksRegex;
  const linkComponent = (_options$component = options === null || options === void 0 ? void 0 : options.component) !== null && _options$component !== void 0 ? _options$component : defaultLinkComponent;
  const elements = [];
  let rest = text;
  let key = 1;

  while (true) {
    const match = linksRegex.exec(rest);
    if (!match || match[0] === undefined) break;
    const urlStartIndex = match.index;
    const urlEndIndex = match.index + match[0].length;
    const textBeforeMatch = rest.slice(0, urlStartIndex);
    const url = rest.slice(urlStartIndex, urlEndIndex).replace(ctrlCharactersRegex, "");
    rest = rest.slice(urlEndIndex);
    elements.push(React.createElement(Fragment, {
      key: `${key}`
    }, textBeforeMatch), linkComponent(/^www\./.exec(url) ? `http://${url}` : url, url, `${key}`, options === null || options === void 0 ? void 0 : options.className));
    key = key + 1;
  }

  elements.push(React.createElement(Fragment, {
    key: `${key}`
  }, rest));

  if (elements.length === 0) {
    return text;
  }

  return elements;
}

function findText(children, options) {
  if (typeof children === "string") {
    return addLinks(children, options);
  }

  if (Array.isArray(children)) {
    return children.map(c => findText(c, options));
  }

  if (isValidElement(children) && children.props.children && children.type !== "a" && children.type !== "button") {
    return cloneElement(children, children.props, findText(children.props.children, options));
  }

  return children;
}
/**
 * AddLinks component can wrapped around any React component to linkify any
 * urls
 * @example
 * ```
 * <AddLinks>
 *  <div>Hello http://world.com</div>
 * </AddLinks>
 * ```
 */


const AddLinks = props => {
  return React.createElement(Fragment, null, findText(props.children, props.options));
};

export { AddLinks, addLinks };
